import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import Root from './pages/RootPage/RootPage';

import './index.css';
import CustomThemeProvider from './components/Theme/CustomThemeProvider';
import { AppProvider } from './data/AppContext';

ReactDOM.render(
  <CustomThemeProvider>
    <AppProvider>
      <Root />
    </AppProvider>
  </CustomThemeProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
